import { getEwsRequestString, createDisplayDate } from 'owa-datetime';
import getOwaTimeZoneOffset from 'owa-datetime-store/lib/utils/getTimezoneOffset';
import { getStartDate } from '../selectors/getStoreProperties';
/**
 * Utility function to get start date time
 * @returns start date time from store
 */
export default function getStartDateTime() {
    var startDate = getStartDate();
    var startDateTime = null;
    if (startDate !== null) {
        var curStart = startDate;
        var startHours = curStart.getHours();
        var startMinutes = curStart.getMinutes();
        var startYear = curStart.getFullYear();
        var startMonth = curStart.getMonth();
        var date = curStart.getDate();
        // Set new start
        var newStart = createDisplayDate(startYear, startMonth, date, startHours, startMinutes);
        /* Offset calculation and appending Z is a temporary fix to overcome the issue at server side
           Bug: 25483 to track the issue. Once resolved, we need to just call getEwsRequestString */
        var offset = getOwaTimeZoneOffset(startDate);
        newStart.setMinutes(newStart.getMinutes() - offset);
        startDateTime = getEwsRequestString(newStart) + 'Z';
    }
    return startDateTime;
}
//# sourceMappingURL=getStartDateTime.js.map